import { ytRegExp, vimeoRegExp } from './regex';

const getVideoType = (url = '') => {
  if (!url) return undefined;

  return ytRegExp.test(url) || vimeoRegExp.test(url) ? 'external' : 'internal';
};

export default getVideoType;
